import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Candidate Access|Login|Self Registration`;

const sharedProps = {
	feature: HubFeature.CandidateAccessLoginSelfRegistration,
	portal: 'CP' as LocPortal,
};

export type CPSelfRegistrationLocs =
	| 'CPSelfRegistrationFormEmailHint'
	| 'CPSelfRegistrationFormPostalCodeRequired'
	| 'CPSelfRegistrationFormPostalCodeVueUSA'
	| 'CPSelfRegistrationFormPostalCodeVueCanada'
	| 'CPSelfRegistrationFormPhoneRequired'
	| 'CPSelfRegistrationFormPhoneVueUsaCanada'
	| 'CPSelfRegistrationFormPhoneVueNoZeros'
	| 'CPSelfRegistrationFormFirstNameQuestionMark'
	| 'CPSelfRegistrationFormLastNameQuestionMark'
	| 'CPSelfRegistrationFormAddressHint';

export const cpSelfRegistrationLocs: LocDefs<CPSelfRegistrationLocs> = {
	CPSelfRegistrationFormEmailHint: {
		defaultValue: '',
		description: 'Hint shown for the email field',
		displayPath: `${dpRoot}|Email Hint`,
		displayType: 'Label',
		...sharedProps,
	},
	CPSelfRegistrationFormPostalCodeRequired: {
		defaultValue: 'Zip/Postal Code is required',
		description: 'Error message shown when the postal code field is required',
		displayPath: `${dpRoot}|Field Error|Postal Code Required`,
		displayType: 'Error',
		portal: 'CP' as LocPortal,
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
	},
	CPSelfRegistrationFormPostalCodeVueUSA: {
		defaultValue: 'Invalid postal code for USA',
		description: 'Error message shown when the postal code is invalid for the US',
		displayPath: `${dpRoot}|Field Error|Postal Code Invalid in USA`,
		displayType: 'Error',
		portal: 'CP' as LocPortal,
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
	},
	CPSelfRegistrationFormPostalCodeVueCanada: {
		defaultValue: 'Invalid postal code for Canada',
		description: 'Error message shown when the postal code is invalid for Canada',
		displayPath: `${dpRoot}|Field Error|Postal Code Invalid in Canada`,
		displayType: 'Error',
		portal: 'CP' as LocPortal,
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
	},
	CPSelfRegistrationFormPhoneRequired: {
		defaultValue: 'Phone number is required',
		description: 'Error message shown when the phone number field is required',
		displayPath: `${dpRoot}|Field Error|Phone Required`,
		displayType: 'Error',
		portal: 'CP' as LocPortal,
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
	},
	CPSelfRegistrationFormPhoneVueUsaCanada: {
		defaultValue: 'Invalid phone number for USA or Canada',
		description: 'Error message shown when the phone number is invalid for the US or Canada',
		displayPath: `${dpRoot}|Field Error|Phone Invalid in USA or Canada`,
		displayType: 'Error',
		portal: 'CP' as LocPortal,
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
	},
	CPSelfRegistrationFormPhoneVueNoZeros: {
		defaultValue: 'Phone number must not contain all zeros',
		description: 'Error message shown when the phone number contains all zeros',
		displayPath: `${dpRoot}|Field Error|Phone All Zeros`,
		displayType: 'Error',
		portal: 'CP' as LocPortal,
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
	},
	CPSelfRegistrationFormFirstNameQuestionMark: {
		defaultValue: 'First name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: `${dpRoot}|Field Error|First Name|Question Marks`,
		displayType: 'Error',
		...sharedProps,
	},
	CPSelfRegistrationFormLastNameQuestionMark: {
		defaultValue: 'Last name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: `${dpRoot}|Field Error|Last Name|Question Marks`,
		displayType: 'Error',
		...sharedProps,
	},
	CPSelfRegistrationFormAddressHint: {
		defaultValue: '',
		description: 'Hint for address.',
		displayPath: `${dpRoot}|Address Hint`,
		displayType: 'Content',
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CPSelfRegistrationLocs>(cpSelfRegistrationLocs);
